import { CSSProperties, ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Position } from 'coreOld/enums';

interface InputWrapperProps {
  fullWidth?: boolean;
  hidden?: boolean;
  labelPosition?: Position;
  style?: CSSProperties;
  children?: ReactNode;
}

export const InputWrapper = styled.div<InputWrapperProps>`
  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}

  ${({ hidden }) =>
    hidden &&
    css`
      display: none;
    `}

  ${({ labelPosition }) => {
    switch (labelPosition) {
      case Position.LEFT:
        return css`
          display: -ms-grid;
          display: grid;
          -ms-grid-columns: 1fr 1fr;
          grid-template-columns: 1fr 1fr;
          align-items: center;
          margin-top: 5px;
        `;
      case Position.TOP:
        return css``;
      default:
        return css``;
    }
  }};

  ${({ style }) => ({ ...style })}
`;
